module.exports = __webpack_public_path__ + "img/Gallery_2_15.377233d8.jpeg";